import isArray from 'lodash/isArray'

export const serializeGetParams = (params: Record<string, string | string[]>) => {
  const url = new URLSearchParams()

  Object.entries(params).forEach(([key, value]: [string, string | string[]]) => {
    if (isArray(value)) {
      value.forEach((str) => url.append(key, str))
    } else {
      url.append(key, value)
    }
  })

  return url.toString()
}
